import axios from 'axios';
import { getToken, logout } from './auth';
import { handleErrorRequest } from '../utils/errorsValidation';

const api = axios.create({
   baseURL: process.env.REACT_APP_BASE_URL_API || 'http://localhost:61447/v1/'
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Tratamento específico para expiração de sessão
    if (error?.response?.status === 401 && error?.response?.data?.complemento?.codigo === '002') {
      const canRedirect = logout();
      if (canRedirect) {
        window.location = '/app';
      }
      return Promise.reject(error);
    }

    // Mecanismo global de tratamento de erros da API
    // Captura mensagens vindas do backend e exibe via toast,
    // evitando telas em branco quando alguma chamada falha.
    if (error?.config?.skipGlobalErrorHandler) {
      return Promise.reject(error);
    }
    try {
      handleErrorRequest(error?.response || error);
    } catch (e) {
      // Em último caso, garante uma mensagem genérica
      // sem quebrar o fluxo da aplicação.
    }

    return Promise.reject(error);
  },
);

export default api;
